function TreatmentHistoryMeedyVO(id, type, beginDate, endDate, current, description, treatment, medication,
                            concomitantDiseases, assistiveDevices, crutches, wheelchair, prosthesis, otherAssistiveDevices,
                            physicianSupervision, otherSupervision, symptoms, supervisionHoursPerWeek) {

  this.id = id;
  this.type = type;
  this.beginDate = beginDate;
  this.endDate = endDate;
  this.current = current == true;
  this.description = description;
  this.treatment = treatment;
  this.medication = medication;
  this.concomitantDiseases = concomitantDiseases;
  this.assistiveDevices = assistiveDevices == true;
  this.crutches = crutches == true;
  this.wheelchair = wheelchair == true;
  this.prosthesis = prosthesis == true;
  this.otherAssistiveDevices = otherAssistiveDevices == true;
  this.physicianSupervision = physicianSupervision == true;
  this.otherSupervision = otherSupervision == true;
  this.symptoms = symptoms;
  this.supervisionHoursPerWeek = supervisionHoursPerWeek;

  var _typeContext = {
    beginDate : Date,
    endDate : Date,
    treatment : TreatmentMeedyVO
  };

  this._getType = function (property) {
    if (_typeContext.hasOwnProperty(property)) {
      return _typeContext[property];
    }
    else {
      return undefined;
    }
  };

  var _mappingContext = {};

  this._getMapping = function (property) {
    if (_mappingContext[property]) {
      return _mappingContext[property];
    }
    else {
      return undefined;
    }
  };
}
